import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {BaseService, httpOptions} from "@core/service/base.service";
import {catchError, retry, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({
  providedIn: 'root'
})
export class PurRequisitionService extends BaseService{

  private url = 'api/purRequisition';

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }


  getIds(ids:any):Observable<any> {
    const url = this.url+'/ids';
    let idss ={ids:ids};
    return this.http.put<any>(url,ids, httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('查询出错'))
    );
  }

  syncFromErp(erpSyncObj:any):Observable<any> {
    const url = this.url+'/sync-from-sap';
    return this.http.post<any>(url,erpSyncObj,httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('同步出错'))
    );
  }

  syncApproval(purRequisitionRelease:any):Observable<any> {
    const url = this.url + '/sync-approval';
    return this.http.post<any>(url,purRequisitionRelease, httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('同步出错'))
    );
  }

  syncBlocked(purRequisitionRelease:any):Observable<any> {
    const url = this.url + '/sync-blocked';
    return this.http.post<any>(url,purRequisitionRelease, httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('同步出错'))
    );
  }

  findPurAccountByPurRequisitionId(id:any):Observable<any> {
    const url = this.url + '/find-pur-account-by-prId/'+id;
    return this.http.get<any>(url, httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('同步出错'))
    );
  }

  findPurRequisitionDetailByCode(codes:any):Observable<any> {
    const url = this.url + '/findPurDetailByCode/'+codes;
    return this.http.get<any>(url, httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('同步出错'))
    );
  }

  findPurRequisitionDetailByCode2(codes:any,num:any):Observable<any> {
    const url = this.url + '/findPurDetailByCode/'+codes+'/'+num;
    return this.http.get<any>(url, httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('同步出错'))
    );
  }

  save(dto: any) {
    const url = this.url;
    return this.http.put<any>(url, dto).pipe(
      tap(_ => this.log(`update`)),
      catchError(this.handleError<any>('更新失败'))
    );
  }
  findByFinished():Observable<any>{
    const url = this.url+'/page-approve-finished';
    return this.http.post<any>(url,httpOptions).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>('获取数据出错'))
    );
  }

  getByFinished(params: HttpParams): Observable<any> {
    const url = `${this.getUrl()}/get-all-finished`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }

  //真实删除,用于新建时明细行删除
  realDeleteBatch(id:any[]):Observable<any> {
    let params = new HttpParams();
    for (let item of id) {
      params = params.append("id", item);
    }
    return this.http.delete<any>(this.getUrl()+"/real", {
      headers: httpOptions.headers,
      params: params
    }).pipe(
      tap(_ => this.log(`deleted object list id=${id}`)),
      catchError(this.handleError<any>('delet object list'))
    );
  }

  exportExcel(rules:any[]): Observable<any> {
    const options = {
      responseType: 'blob' as 'json'
    };
    const url = `${this.getUrl()}/exportExcel`;
    return this.http.post<any>(url,rules,options).pipe(
      tap(_ => this.log(`导出成功`)),
      catchError(this.handleError<any>('导出错误')));
  }
}
